import Button, { ButtonType } from '@root/gatsby-contentful-core/src/components/button';
import OverlayModal from '@root/core/src/components/overlay-modal';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import SuccessAnimation from '@root/joinroot.com/src/components/privacy/success-animation';
import Theme from '@root/gatsby-contentful-core/src/components/brand/theme';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';

export default function PrivacyActRequestFormSuccess({ onCancelPress, onDonePress }) {
  return (
    <OverlayModal
      onCancel={onCancelPress}
      visible={true}
    >
      <div css={styles.modalContent}>
        <SuccessAnimation />
        <h5 css={styles.modalHeading}>We’ve received your request. Our team will respond within 10 days.</h5>
        <div css={styles.buttonContainer} >
          <Button
            css={styles.modalButton}
            onClick={onDonePress}
            type={ButtonType.BUTTON}
          >
            Done
          </Button>
        </div>
      </div>
    </OverlayModal>
  );
}

const styles = StyleSheet.create({
  modalContent: {
    margin: '0 5px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: Colors.white(),
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 300,
    minHeight: 400,
    maxWidth: 715,
    ...Responsive.md({
      minWidth: 600,
    }),
    ...Responsive.lg({
      minWidth: 715,
    }),
  },
  animationContainer: {
    height: 60,
    margin: 20,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: '100%',
    marginTop: 35,
    marginBottom: 15,
  },
  modalHeading: {
    ...Theme.cardHeading(),
    width: '80%',
    textAlign: 'center',
    marginTop: 15,
    marginBottom: 15,
  },
  modalButton: {
    paddingLeft: 75,
    paddingRight: 75,
    margin: 10,
  },
});

PrivacyActRequestFormSuccess.propTypes = {
  onCancelPress: PropTypes.func.isRequired,
  onDonePress: PropTypes.func.isRequired,
};
